import moment from 'moment';
import angular from 'angular';
import {reportHasAssetListParam, doNotSupportCustomRang} from '../../models/report.model';
import {get} from 'lodash-es';

export default function JobUpdateController(
  $scope,
  $uibModal,
  $stateParams,
  JobSchedulerService,
  $state,
  $filter,
  securityGroupsService,
  reportsRepository,
  $log,
  usersService,
  gettextCatalog
) {
  'ngInject';

  $scope.$on('totalEmails', function(event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });
  //defualt onei3 schedule report tag
  $scope.tag = 'onei3:schedule:report';

  $scope.submitted = false;
  $scope.resourceUrl = securityGroupsService.getResourceUrl();
  $scope.animationsEnabled = true;
  $scope.existingEquips = [];
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.successFlag = false;

  $scope.equipments = []; //list of equipments to send to the database
  $scope.postRemoval = [];
  $scope.removeFlags = {};
  $scope.filteredEquipmentList = [];
  $scope.equipmentByPage = [];
  $scope.search = {
    text: ''
  };
  $scope.loading = true;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  $scope.dropDownDates = [
    {
      id: 1,
      label: gettextCatalog.getString('7d'),
      reportName: 'Last 7 Days',
      tooltip: gettextCatalog.getString('Last 7 Days')
    },
    {
      id: 2,
      label: gettextCatalog.getString('MTD'),
      reportName: 'Month-To-Date',
      tooltip: gettextCatalog.getString('Month-To-Date')
    },
    {
      id: 3,
      label: gettextCatalog.getString('30d'),
      reportName: 'Last 30 Days',
      tooltip: gettextCatalog.getString('Last 30 Days')
    },
    {
      id: 4,
      label: gettextCatalog.getString('90d'),
      reportName: 'Last 90 Days',
      tooltip: gettextCatalog.getString('Last 90 Days')
    }
  ];

  const updateSchedulerRequiredAssetProp = reportParams => {
    const reportNeedAssets = reportHasAssetListParam(reportParams);
    $scope.schedule = {...($scope.schedule || {}), reportDoesNotRequireAssets: !reportNeedAssets};
  };

  let getSchedule = function() {
    JobSchedulerService.getSchedule($stateParams.id)
      .then(
        function(response) {
          $scope.loading = true;
          let data = response.data;
          getScheduleRepresentation(data);
          $scope.selectedDateRange = $scope.schedule.dateRange;
          return reportsRepository.getReport(data.reportId);
        },
        function() {
          $scope.errorFlag = true;
          $scope.errorText = gettextCatalog.getString('Unexpected error occurred while getting the schedule');
        }
      )
      .then(
        function(response) {
          let attrs = response.data.data.attributes.attrs;
          const reportParams = get(response, 'data.data.relationships.ssrsReport.data.attributes.parameters', []);
          updateSchedulerRequiredAssetProp(reportParams);
          const validDateRangeOption = (reportParams.find(p => p.name === 'drop_DateRange') || {}).validValues || [];
          const validOptions = validDateRangeOption.map(op => op.value);
          if (validOptions.length) {
            $scope.dropDownDates = $scope.dropDownDates.filter(opt => validOptions.includes(`${opt.id}`));
          }

          $scope.prefilter = attrs.prefilter;
          $scope.dateRangeType = attrs.dateRange ? attrs.dateRange : '';
          $scope.maxSelection =
            attrs.prefilter && attrs.prefilter.indexOf('onei3:model') && attrs.prefilter.indexOf('m3') ? 1 : undefined;
        },
        function() {
          $scope.errorFlag = true;
          $scope.errorText = gettextCatalog.getString('Unexpected error occurred while getting the report');
        }
      )
      .finally(function() {
        $scope.loading = false;
        $scope.$emit('$viewContentLoaded');
      });
  };

  getSchedule($stateParams.id);

  let getScheduleRepresentation = function(data) {
    $scope.schedule = {
      id: data.id,
      jobName: data.jobName,
      startDate: moment(data.startAt).toDate(),
      dateRange: $scope.dropDownDates.find(opt => `${opt.id}` === data.reportParameters.drop_DateRange),
      selectedAssets: data.equipment,
      reportPath: data.reportPath,
      reportName: data.reportName,
      type: data.attrs.type,
      deliveryTime: {
        dateTime: moment(data.startAt).toDate()
      },
      reportParameters: data.reportParameters,
      enabled: true,
      contacts: data.contacts,
      recurrence: data.recurrence.frequency,
      reportDoesNotRequireAssets: false
    };
  };

  $scope.firstCall = false;
  $scope.user = usersService.currentUser();
  $scope.selectedAssets = [];
  $scope.openDatePickers = {};
  $scope.status = {
    isFirstOpen: false,
    isFirstDisabled: false
  };
  $scope.reportParam = [];
  $scope.exportList = [];
  $scope.startDateIndex = -1;
  $scope.endDateIndex = -1;

  //Local variables
  $scope.usersByPage = [];
  $scope.userData = [];
  $scope.filteredUserData = [];
  $scope.query = '';
  $scope.search = {
    text: ''
  };
  $scope.loading = false;

  //Pagination
  $scope.currentPage = {};
  $scope.bigCurrentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.maxSize = 1;

  $scope.today = function() {
    $scope.dt = moment().toDate();
  };
  $scope.today();

  $scope.clear = function() {
    $scope.dt = null;
  };

  // Disable weekend selection
  $scope.disabled = function(date, mode) {
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  };

  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };

  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[3];

  $scope.status = {
    //opened: false
    isFirstOpen: false,
    isFirstDisabled: false
  };

  $scope.emails = [];
  $scope.$on('disableDate', function(event, args) {
    $scope.date_checked = args.Calendar;
  });

  function processPreFilter(input) {
    let prefilter = {};
    if (typeof input === 'string') {
      let unescaped = (input || '').replace(/\\/g, '"');
      prefilter = JSON.parse(unescaped);
    } else if (typeof input === 'object') {
      prefilter = input;
    }

    return prefilter;
  }

  //Pagination
  $scope.current = {
    equipmentPage: 1,
    usersPage: 1
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  $scope.open = function() {
    let modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: $scope.maxSelection === 1,
        requiresSelection: false,
        prefilter: function() {
          return processPreFilter($scope.prefilter);
        },
        maxSelection: function() {
          return $scope.maxSelection;
        },
        selectedAssets: function() {
          let selected = {};

          if ($scope.schedule.selectedAssets) {
            for (let i = 0; i < $scope.schedule.selectedAssets.length; i++) {
              let e = $scope.schedule.selectedAssets[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
        pickerSettings: () => ({canSelectAll: true})
      }
    });

    modalInstance.result.then(function(selectedAssets) {
      let arr = [];
      for (let key in selectedAssets.result) {
        arr.push(selectedAssets.result[key]);
      }
      $scope.schedule.selectedAssets = arr;
      $scope.numSelectedAssets = $scope.schedule.selectedAssets.length;
    });
  };

  $scope.toggleAnimation = function() {
    $scope.animationsEnabled = !$scope.animationsEnabled;
  };

  let gatherDataNewReq = function(scheduleAttributes) {
    $scope.schedule = scheduleAttributes;
    $scope.schedule.startDate = moment($scope.schedule.startDate).toDate();
    $scope.schedule.startDate.setHours(
      $scope.schedule.deliveryTime.dateTime.getHours(),
      $scope.schedule.deliveryTime.dateTime.getMinutes()
    );
    for (let key in $scope.schedule.reportParameters) {
      if ($scope.schedule.reportParameters.hasOwnProperty(key)) {
        switch (key) {
          case 'AccountId':
            $scope.schedule.reportParameters[key] = $scope.user.account.id;
            break;
          case 'UserName':
            $scope.schedule.reportParameters[key] = $scope.user.username;
            break;
          case 'drop_DateRange':
            $scope.schedule.reportParameters[key] = $scope.schedule.dateRange.id;
            break;
          case 'UserTZ':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.timezone
              ? moment.tz(Date.now(), $scope.user.claims.data.timezone).format('z')
              : 'UTC';
            break;
          case 'UserUOM':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.unitOfMeasure;
            break;
          case 'TimeZoneId':
            $scope.schedule.reportParameters[key] = $scope.user.claims.data.timezone
              ? $scope.user.claims.data.timezone
              : 'UTC';
            break;
        }
      }
    }
    let data = {
      jobName: $scope.schedule.jobName,
      reportPath: $scope.schedule.reportPath,
      reportName: $scope.schedule.reportName,
      startAt: $scope.schedule.startDate,
      recurrence: {
        frequency: $scope.schedule.recurrence,
        interval: 1
      },
      contacts: $scope.schedule.contacts,
      reportParameters: $scope.schedule.reportParameters,
      tags: [$scope.tag],

      attrs: {
        scheme: 'reports',
        type: $scope.schedule.type
      },
      equipment: (function() {
        let arr = [];
        angular.forEach($scope.schedule.selectedAssets, function(asset) {
          if (typeof asset === 'string') {
            arr.push({
              id: asset,
              name: asset
            });
          } else {
            arr.push({
              id: asset.id,
              name: asset.name
            });
          }
        });
        return arr;
      })()
    };
    $scope.schedule.data = data;
    return $scope.schedule;
  };
  let isValid = function(schedule) {
    let diff = schedule.startDate.getTime() - schedule.minDate.getTime();
    let minDifference = -60000;
    const validAssets = schedule.reportDoesNotRequireAssets ? true : schedule.selectedAssets.length > 0;
    if (
      schedule.jobName &&
      validAssets &&
      schedule.contacts.length > 0 &&
      schedule.contacts.length <= $scope.maxEmails &&
      schedule.dateRange &&
      schedule.startDate &&
      schedule.deliveryTime.dateTime &&
      diff > minDifference
    ) {
      return true;
    } else {
      return false;
    }
  };

  $scope.updateSchedule = function() {
    //update
    $scope.submitted = true;
    $scope.numSelectedAssets = $scope.schedule.selectedAssets.length;
    $scope.schedule.minDate = moment().toDate();
    if ($scope.schedule.minDate > $scope.schedule.startDate) {
      $scope.schedule.minDate = $scope.schedule.startDate;
    }
    $scope.maxEmails = $scope.maxEmails ? $scope.maxEmails : $scope.schedule.contacts.length;
    if (!isValid($scope.schedule)) {
      return false;
    }
    $scope.updating = true;

    let newData = gatherDataNewReq($scope.schedule);
    JobSchedulerService.updateSchedule(newData).then(
      function() {
        $scope.updating = false;
        $state.go('reports.jobscheduledetail', {
          id: $scope.schedule.id
        });
      },
      function() {
        $scope.updating = false;
        $scope.errorFlag = true;
        $scope.errorText = gettextCatalog.getString('Unexpected error occurred while updating the schedule');
      }
    );
  };
}
